
<header>
	<div>
		<a href="https://github.com/vincjo/svelte-simple-datatables#readme">
			<img alt="github logo" src="github.svg"/><span>Github</span>
		</a>
	</div>
</header>



<style>
	header {font-weight:300;padding:0;height:40px;position:fixed;top:0;right:0;z-index:200;color:#212121;}  
	header a {text-decoration: none;padding:0;display: block;font-size:16px;line-height:40px;}
	div{display:flex;margin-right:16px;float:right;background:#fff;}
	img{float:left;padding:8px 8px;width:40px;}
</style>